/** Per-item price drafts as RUBLE STRINGS (AmountInput contract, SPEC §2). */
export type PriceDraft = Record<string, string>;

/**
 * Re-seed a price draft from a fresh server copy WITHOUT losing what the owner
 * typed since the last seed.
 *
 * `seed`      — the new baseline (server prices + memory auto-fill).
 * `prevBase`  — the baseline the live draft was last seeded from.
 * `prevDraft` — the live draft (may contain unsaved edits).
 *
 * For every line in `seed`: if the owner changed that line since the previous
 * seed (`prevDraft` differs from `prevBase`), the owner's value wins; otherwise
 * the server/baseline value is taken. Lines missing from `seed` are dropped,
 * lines new in `seed` come in as-is. So a background refetch (a transfer, a
 * return, a webhook re-sync) never wipes an input the owner is mid-typing.
 */
export function mergeDraft(seed: PriceDraft, prevBase: PriceDraft, prevDraft: PriceDraft): PriceDraft {
  const out: PriceDraft = {};
  for (const [itemId, seedValue] of Object.entries(seed)) {
    const base = prevBase[itemId];
    const live = prevDraft[itemId];
    const edited = base !== undefined && live !== undefined && live !== base;
    out[itemId] = edited ? live : seedValue;
  }
  return out;
}
